import React, { useState, useEffect, useRef } from "react";

import ApiClient from "../services/fuelandmoreapi";

import type { TPort } from "@/types";

import "./SearchPort.css"; // Import the new CSS file

import { config } from "../config";

interface SearchPortProps {
  onSelect: (port: TPort) => void;
}

const SearchPort: React.FC<SearchPortProps> = ({ onSelect }) => {
  const [query, setQuery] = useState("");
  const [ports, setPorts] = useState<TPort[]>([]);
  const [loading, setLoading] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const { apiBaseUrl } = config;
  const apiUrl = apiBaseUrl;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const fetchPorts = async () => {
      if (query.length < 3) {
        setPorts([]);
        return;
      }

      setLoading(true);
      try {
        const apiClient = new ApiClient(`${apiUrl}`);
        const result = await apiClient.getPorts(query);
        setPorts(result.data);
      } catch (error) {
        console.error("Error fetching ports:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(fetchPorts, 300);
    return () => clearTimeout(debounceTimeout);
  }, [query]);

  const handleSelect = (port: TPort) => {
    onSelect(port);
    setQuery("");
    setPorts([]);
  };

  return (
    <div className="search-port-wrapper">
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search for a port..."
        className="search-port-input"
      />
      {loading && <p className="search-port-loading">Loading...</p>}
      <div className="search-port-results">
        <ul className="search-port-list">
          {ports.map((port) => (
            <li
              key={port.unlocode}
              onClick={() => handleSelect(port)}
              className="search-port-item"
            >
              {port.name} ({port.unlocode})
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SearchPort;
